import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { nb } from 'date-fns/locale';

const setLocale = () => {
  registerLocale('nb', nb);
  setDefaultLocale('nb');
};

export default setLocale;
